import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
// import { SelectHomeComponent } from 'app/components/select-home/select-home.component';
// import { AnnouncementsComponent } from './announcements/announcements.component';

@NgModule({
    // imports:[MatDialogModule],
    imports: [
        MatDialogModule,
        // SelectHomeComponent,hhjhhhh
        //  AnnouncementsComponent
    ],
})
export class LandingHomeModule {}
